const AUTH_API_BASE = import.meta.env.VITE_XANO_AUTH_API_BASE_URL || ''
const CRP_API_BASE = import.meta.env.VITE_XANO_CRP_API_BASE_URL || ''
const WEBHOOK_API_BASE = import.meta.env.VITE_XANO_WEBHOOK_API_BASE_URL || ''

const TOKEN_KEY = 'crp_auth_token'

export function getAuthToken() {
  return localStorage.getItem(TOKEN_KEY)
}

export function setAuthToken(token) {
  localStorage.setItem(TOKEN_KEY, token)
}

export function clearAuthToken() {
  localStorage.removeItem(TOKEN_KEY)
}

function getAuthHeaders() {
  const token = getAuthToken()
  return token ? { Authorization: `Bearer ${token}` } : {}
}

async function handleResponse(response) {
  if (!response.ok) {
    const error = await response.json().catch(() => ({ message: 'Request failed' }))
    throw new Error(error.message || `HTTP error ${response.status}`)
  }
  return response.json()
}

export async function login(email, password) {
  const response = await fetch(`${AUTH_API_BASE}/auth/login`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ email, password }),
  })
  return handleResponse(response)
}

export async function getMe() {
  const response = await fetch(`${AUTH_API_BASE}/auth/me`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      ...getAuthHeaders(),
    },
  })
  return handleResponse(response)
}

export async function loginWithViewerToken(token) {
  const response = await fetch(`${AUTH_API_BASE}/auth/viewer`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ token }),
  })
  return handleResponse(response)
}

export async function getRequests(customerId = null, isViewer = false) {
  let url
  if (isViewer) {
    url = `${CRP_API_BASE}/crp/viewer/requests`
  } else if (customerId) {
    url = `${CRP_API_BASE}/crp/requests?customer_id=${customerId}`
  } else {
    url = `${CRP_API_BASE}/crp/requests`
  }
  const response = await fetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      ...getAuthHeaders(),
    },
  })
  return handleResponse(response)
}

export async function updatePriority(linkId, priority) {
  const response = await fetch(`${CRP_API_BASE}/crp/requests/${linkId}/priority`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      ...getAuthHeaders(),
    },
    body: JSON.stringify({ customer_priority: priority }),
  })
  return handleResponse(response)
}

export async function reorderRequests(items) {
  const response = await fetch(`${CRP_API_BASE}/crp/requests/reorder`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      ...getAuthHeaders(),
    },
    body: JSON.stringify({ items }),
  })
  return handleResponse(response)
}

export async function getCustomers() {
  const response = await fetch(`${CRP_API_BASE}/crp/customers`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      ...getAuthHeaders(),
    },
  })
  return handleResponse(response)
}

export async function generateViewerToken(customerId) {
  const response = await fetch(`${CRP_API_BASE}/crp/customers/generate-token`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...getAuthHeaders(),
    },
    body: JSON.stringify({ customer_id: customerId }),
  })
  return handleResponse(response)
}
